import { Routes } from '@angular/router';

export const userCollectionManageRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./user-collection-manage.page').then(
        (m) => m.UserCollectionManagePage
      ),
  },
];
